var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "border", attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [_c("h4", [_vm._v(":: Oficinas")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "b-link",
                                { attrs: { to: { name: "BrandListOffices" } } },
                                [_vm._v("Clientes por Oficinas")]
                              ),
                              _vm._v(" » "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href:
                                      "/clients-by-offices/brand/" +
                                      _vm.office.slug
                                  }
                                },
                                [
                                  _vm._v(
                                    "Lista de Oficinas de " +
                                      _vm._s(_vm.office.brand)
                                  )
                                ]
                              ),
                              _vm._v(
                                " » " +
                                  _vm._s(_vm.office.name) +
                                  ":\n                "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pb-2 cliente-detalle mb-4" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "text-left pr-4 pl-4",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("label", [_vm._v("Nombre:")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.office.name))
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Dirección:")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.office.address))
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Teléfono:")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.office.phone))
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Departamento:")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.office.department))
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Distrito:")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.office.district))
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Marcas:")]),
                                  _vm._v(" "),
                                  _c("strong", [_vm._v(_vm._s(_vm.brands))]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Código SAP:")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.office.codigo_sap))
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.office.status == 1
                                    ? _c("div", [
                                        _c("label", [_vm._v("Estado:")]),
                                        _vm._v(" "),
                                        _c("strong", [_vm._v("Activo")]),
                                        _c("br")
                                      ])
                                    : _c("div", [
                                        _c("label", [_vm._v("Estado:")]),
                                        _vm._v(" "),
                                        _c("strong", [_vm._v("Inactivo")]),
                                        _c("br")
                                      ]),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Creado en:")]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.office.created_at))
                                  ]),
                                  _c("br")
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-4" }),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.editoffice(_vm.office._id)
                                }
                              }
                            },
                            [_vm._v("Editar")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              attrs: { variant: "danger" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteoffice(_vm.office._id)
                                }
                              }
                            },
                            [_vm._v("Eliminar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fcf0c6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fcf0c6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowOffice.vue
// module id = null
// module chunks = 